// ✅ IMPORTANT : Initialiser Sentry EN PREMIER !
// Voir: https://docs.sentry.io/platforms/javascript/guides/react/
import { initSentry } from "./config/sentry";
initSentry();

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import * as Sentry from "@sentry/react";
import { store, persistor } from "./store";
import "./locales/i18n";
import { LanguageProvider } from "./components/LanguageProvider";
import App from "./App";
import "./index.css";

const container = document.getElementById("root");

// ✅ Méthode officielle React 19+ selon la documentation Sentry
// Utilise les nouveaux hooks d'erreur de React 19
// https://docs.sentry.io/platforms/javascript/guides/react/#configure-error-hooks-react-19
const root = ReactDOM.createRoot(container!, {
  // Callback appelé quand une erreur est lancée et non capturée par un ErrorBoundary
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback appelé quand React capture une erreur dans un ErrorBoundary
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback appelé quand React récupère automatiquement d'erreurs
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate
        loading={
          <div className="min-h-screen flex items-center justify-center bg-background">
            <div className="flex flex-col items-center gap-4">
              <div className="animate-spin h-12 w-12 border-4 border-primary border-t-transparent rounded-full"></div>
              <p className="text-sm text-muted-foreground">Chargement...</p>
            </div>
          </div>
        }
        persistor={persistor}
      >
        <LanguageProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LanguageProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
